import { render, staticRenderFns } from "./kuranPageParagraphItem.vue?vue&type=template&id=fc08c138"
import script from "./kuranPageParagraphItem.vue?vue&type=script&lang=js"
export * from "./kuranPageParagraphItem.vue?vue&type=script&lang=js"
import style0 from "./kuranPageParagraphItem.vue?vue&type=style&index=0&id=fc08c138&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports